import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import { Modal, Pagination, Select, Spin, message } from "antd";
import DropdownArrowIcon from "../../../Assets/Images/Svg/dropdownArrow.svg";
import TodaysAppointment from "./TodaysAppointment";
import UpcomeAppointment from "./UpcomeAppointment";
import AddAppointments from "./AddAppointments";
import UpcomingAppointmentFilter from "./UpcomingAppointmentFilter";
import AppointmentService from "../../../Services/AppointmentService";
import TodayAppointmentFilter from "./TodayAppointmentFilter";
// import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import PatientService from "../../../Services/PatientService";
import PatientQueue from "../VCPage/PatientQueue";
import { IoIosCloseCircle } from "react-icons/io";
import Draggable from "react-draggable";
import { FaFilter } from "react-icons/fa6";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";

function Appointments() {
  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const [selectedOption, setSelectedOption] = useState("Today Appointments");
  const [upcomingList, setUpcomingList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [appointmentList, setAppointmentList] = useState([]);
  const [todayModal, setTodayModal] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [filterDate, setFilterDate] = useState("");
  const [maintainbg, setMaintainbg] = useState(true);
  const [loading, setLoading] = useState(false);
  const [apiPayload, setApiPayload] = useState({});

  const [todayStatusValue, setTodayStatusValue] = useState("");
  const [todayTypeValue, setTodayTypeValue] = useState("1");

  const [upcomingStatusValue, setUpcomingStatusValue] = useState("");
  const [upcomingTypeValue, setUpcomingTypeValue] = useState("1");

  const [isVerticalOpen, setIsVerticalOpen] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [hasMore, setHasMore] = useState(true);

  const [currentUpcomingPage, setCurrentUpcomingPage] = useState(1);
  const [hasMoreUpcoming, setHasMoreUpcoming] = useState(true);

  useEffect(() => {
    getAppointmentList();
  }, []);

  const showModal = () => setIsModalOpen(true);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);

  const showTodayModal = () => setTodayModal(true);
  const todayFilter = () => setTodayModal(false);
  const todayCancel = () => setTodayModal(false);

  const fromDate = new Date();
  const formattedDate = fromDate.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowDate = tomorrow.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  const months = new Date();
  months.setDate(months.getDate() + 30);
  const futureDate = months.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    if (option == "Today Appointments") {
      getAppointmentList();
      setFilterDate("");
      setMaintainbg(true);
    } else {
      upcomingAppointmentList();
      setFilterDate("");
      setMaintainbg(true);
    }
  };

  const getAppointmentList = () => {
    setLoading(true);
    let payload = {
      userId: loginResultObject.user.userId,
      clinic_Id: loginResultObject.user.clinic_Id,
      fromDate: formattedDate,
      pageNo: currentPage,
      pageSize: pageSize,
    };
    setApiPayload(payload);
    AppointmentService.AppointmentFilter(payload)
      .then((result) => {
        setAppointmentList(result.data);
        setLoading(false);
        setTodayStatusValue("");
        setTodayTypeValue("1");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const todayStatus = (value) => {
    setTodayStatusValue(value);
    apiPayload.status = value;
    // let payload = {
    //   status: value,
    //   fromDate: formattedDate,
    //   userId: loginResultObject.user.userId,
    // };
    AppointmentService.AppointmentFilter(apiPayload)
      .then((result) => {
        setAppointmentList(result.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const todayTypeChange = (value) => {
    setTodayTypeValue(value);
    if (value === "1") {
      let payload = {
        userId: loginResultObject.user.userId,
        fromDate: apiPayload.fromDate ? apiPayload.fromDate : formattedDate,
        clinic_Id: loginResultObject.user.clinic_Id,
      };
      AppointmentService.AppointmentFilter(payload)
        .then((result) => {
          setAppointmentList(result.data);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      apiPayload.serviceCode = value;
      // let payload = {
      //   serviceCode: value,
      //   userId: loginResultObject.user.userId,
      //   fromDate: formattedDate,
      // };
      AppointmentService.AppointmentFilter(apiPayload)
        .then((result) => {
          setAppointmentList(result.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const upcomingAppointmentList = () => {
    setLoading(true);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowDate = tomorrow.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    const months = new Date();
    months.setDate(months.getDate() + 30);
    const futureDate = months.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    let payload = {
      userId: loginResultObject.user.userId,
      fromDate: tomorrowDate,
      toDate: futureDate,
      clinic_Id: loginResultObject.user.clinic_Id,
      pageNo: currentUpcomingPage,
      pageSize: pageSize,
    };
    setApiPayload(payload);
    AppointmentService.AppointmentFilter(payload)
      .then((result) => {
        setUpcomingList(result.data);
        setLoading(false);
        setUpcomingStatusValue("");
        setUpcomingTypeValue("1");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleUpcomingStatus = (value) => {
    setUpcomingStatusValue(value);
    // let payload = {
    //   status: value,
    //   userId: loginResultObject.user.userId,
    //   fromDate: tomorrowDate,
    //   toDate: futureDate,
    // };
    apiPayload.status = value;
    AppointmentService.AppointmentFilter(apiPayload)
      .then((result) => {
        setUpcomingList(result.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const upcomingTypeChange = (value) => {
    setUpcomingTypeValue(value);
    if (value === "1") {
      // let payload = {
      //   status: value,
      //   userId: loginResultObject.user.userId,
      //   fromDate: tomorrowDate,
      //   toDate: futureDate,
      // };
      apiPayload.status = value;
      AppointmentService.AppointmentFilter(apiPayload)
        .then((result) => {
          setUpcomingList(result.data);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      // let payload = {
      //   serviceCode: value,
      //   userId: loginResultObject.user.userId,
      //   toDate: tomorrowDate,
      // };
      apiPayload.serviceCode = value;
      AppointmentService.AppointmentFilter(apiPayload)
        .then((result) => {
          setUpcomingList(result.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const onClose = () => {
    setIsDrawerOpen(false);
  };

  const showDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleClick = () => {
    setIsVerticalOpen(true);
  };
  const closeCircle = () => {
    setIsVerticalOpen(false);
  };

  const handlePageChange = (page, size) => {
    apiPayload.pageNo = page;
    apiPayload.pageSize = size;

    AppointmentService.AppointmentFilter(apiPayload)
      .then((result) => {
        setHasMore(result.data?.length === size);
        setAppointmentList(result.data);
        setCurrentPage(page);
        setPageSize(size);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleUpcomingPageChange = (page, size) => {
    apiPayload.pageNo = page;
    apiPayload.pageSize = size;

    AppointmentService.AppointmentFilter(apiPayload)
      .then((result) => {
        setHasMoreUpcoming(result.data?.length === size);
        setUpcomingList(result.data);
        setCurrentUpcomingPage(page);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Layouts>
      <div className="">
        <div className="flex justify-between items-center mb-8 ">
          <div className="font-bold font-sans text-lg">Appointments</div>
          <div className="flex gap-2">
            <AddAppointments getAppointmentList={getAppointmentList} />
          </div>
        </div>
        <div className="md:flex justify-between items-center mb-8">
          <div className="w-[350px] md:w-[500px] flex md:gap-2 items-center -ml-4 md:ml-0 mb-4">
            <div className="flex justify-center items-center cursor-pointer rounded-full border bg-white">
              <div
                className={`rounded-full md:px-8 px-2 py-2 font-sans font-medium text-xs md:text-base ${
                  selectedOption == "Today Appointments" && maintainbg
                    ? "bg-brand-primaryColor text-white"
                    : "text-gray-600"
                }`}
                onClick={() => handleOptionChange("Today Appointments")}
              >
                Today Appointments
              </div>
              <div
                className={`rounded-full md:px-8 px-2 py-2 font-medium font-sans text-xs md:text-base ${
                  selectedOption == "Upcoming Appointments" && maintainbg
                    ? "bg-brand-primaryColor text-white"
                    : "text-gray-600"
                }`}
                onClick={() => handleOptionChange("Upcoming Appointments")}
              >
                Upcoming Appointments
              </div>
            </div>
          </div>
          {/* today appointment filter */}
          {selectedOption === "Today Appointments" && (
            <div className=" flex md:gap-5 gap-2 ">
              <div className="flex items-center gap-5">
                <Select
                  className="md:w-36 w-24 h-4 md:h-10"
                  placeholder="Status"
                  suffixIcon={<img src={DropdownArrowIcon} alt="img" />}
                  onChange={todayStatus}
                  // value={todayStatusValue}
                >
                  <Select.Option value="2">Completed</Select.Option>
                  <Select.Option value="9">Cancelled</Select.Option>
                  <Select.Option value="1">Pending</Select.Option>
                </Select>
              </div>
              <div className="flex items-center gap-5">
                <Select
                  className="md:w-36 w-24 md:h-10 h-4"
                  defaultValue="All Consultations"
                  suffixIcon={<img src={DropdownArrowIcon} alt="img" />}
                  onChange={todayTypeChange}
                  value={todayTypeValue}
                >
                  <Select.Option value="APPT_INPERSON">In-person</Select.Option>
                  <Select.Option value="APPT_VIDEO">Video</Select.Option>
                  <Select.Option value="1">All Consultation</Select.Option>
                </Select>
              </div>
              <div className="flex gap-2 items-center justify-end">
                <button
                  className="text-white md:p-2 px-2 py-1 bg-brand-primaryColor rounded-md flex items-center "
                  onClick={showTodayModal}
                >
                  <FaFilter className="md:mr-1" />
                  Filter
                </button>
              </div>
            </div>
          )}
          {/* upcoming appointment logic comes here */}
          {selectedOption === "Upcoming Appointments" && (
            <div className=" flex gap-5 ">
              <div className="flex items-center md:gap-5 gap-2">
                <Select
                  className="md:w-36 w-24 md:h-10 h-6"
                  placeholder="Status"
                  suffixIcon={<img src={DropdownArrowIcon} alt="img" />}
                  onChange={handleUpcomingStatus}
                  // value={upcomingStatusValue}
                >
                  <Select.Option value="9">Cancelled</Select.Option>
                  <Select.Option value="1">Pending</Select.Option>
                </Select>
              </div>
              <div className="flex items-center md:gap-5 gap-2">
                <Select
                  className="md:w-36 w-24 md:h-10 h-6"
                  defaultValue="All Consultations"
                  suffixIcon={<img src={DropdownArrowIcon} alt="img" />}
                  onChange={upcomingTypeChange}
                  value={upcomingTypeValue}
                >
                  <Select.Option value="APPT_INPERSON">In-person</Select.Option>
                  <Select.Option value="APPT_VIDEO">Video</Select.Option>
                  <Select.Option value="1">All Consultation</Select.Option>
                </Select>
              </div>
              <div className="flex md:ml-4 items-center justify-end">
                <button
                  className="text-white md:p-2 p-1 bg-brand-primaryColor rounded-md flex items-center "
                  onClick={showModal}
                >
                  <FaFilter className="md:mr-1" />
                  Filter
                </button>
              </div>
            </div>
          )}
        </div>
        {filterDate !== "" && (
          <div className="my-4">
            <span className="font-bold">Appointment Date :</span> {filterDate}
          </div>
        )}
        {loading ? (
          <div className="flex justify-center items-center mt-40">
            <Spin />
          </div>
        ) : (
          <>
            <div className="rounded-xl p-1 h-full">
              {selectedOption === "Today Appointments" && (
                <>
                  <TodaysAppointment
                    appointmentList={appointmentList}
                    getAppointmentList={getAppointmentList}
                    apiPayload={apiPayload}
                    setApiPayload={setApiPayload}
                    setAppointmentList={setAppointmentList}
                  />
                  <div className="flex justify-end text-[#189FAA] items-center my-10">
                    <Pagination
                      align="end"
                      current={currentPage}
                      total={
                        hasMore
                          ? currentPage * pageSize + 1
                          : currentPage * pageSize
                      }
                      pageSize={pageSize}
                      onChange={handlePageChange}
                      showSizeChanger={false}
                    />
                  </div>
                </>
              )}

              {selectedOption === "Upcoming Appointments" && (
                <>
                  <UpcomeAppointment
                    upcomingList={upcomingList}
                    setUpcomingList={setUpcomingList}
                    upcomingAppointmentList={upcomingAppointmentList}
                  />
                  <div className="flex justify-end items-center my-10">
                    <Pagination
                      align="end"
                      current={currentUpcomingPage}
                      total={
                        hasMoreUpcoming
                          ? currentUpcomingPage * pageSize + 1
                          : currentUpcomingPage * pageSize
                      }
                      pageSize={pageSize}
                      onChange={handleUpcomingPageChange}
                      showSizeChanger={false}
                    />
                  </div>
                </>
              )}
            </div>

            {/* patient queue design */}
            {isVerticalOpen ? (
              <Draggable>
                <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
                  <div
                    className="hidden md:block relative mb-5 cursor-pointer"
                    onClick={closeCircle}
                  >
                    <IoIosCloseCircle className="hidden md:block text-red-400 absolute mb-1 right-0 top-0" />
                  </div>
                  <img
                    src={patientqueue}
                    alt="patientqueue"
                    className=" cursor-pointer"
                    title="Patient Queue"
                    onClick={showDrawer}
                  />
                </div>
              </Draggable>
            ) : (
              <div
                className="vertical"
                style={{ marginTop: "16rem" }}
                onClick={handleClick}
              >
                <p className="vertical-p">
                  <div className="vertical-icon-dashboard">
                    <MdKeyboardDoubleArrowUp />
                  </div>
                  Queue
                </p>
              </div>
            )}

            {isDrawerOpen && (
              <div className="grid justify-end mt-5">
                {isDrawerOpen && <PatientQueue onClose={onClose} />}
              </div>
            )}
          </>
        )}

        {todayModal && (
          <Modal
            title="Appointments"
            open={todayModal}
            onOk={todayFilter}
            onCancel={todayCancel}
            footer={[]}
          >
            <TodayAppointmentFilter
              setFilterDate={setFilterDate}
              upcomingList={upcomingList}
              setAppointmentList={setAppointmentList}
              todayFilter={todayFilter}
              todayCancel={todayCancel}
              setMaintainbg={setMaintainbg}
              setApiPayload={setApiPayload}
              setTodayStatusValue={setTodayStatusValue}
              setTodayTypeValue={setTodayTypeValue}
            />
          </Modal>
        )}

        {isModalOpen && (
          <Modal
            title="Upcoming Appointments"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[]}
          >
            <UpcomingAppointmentFilter
              upcomingList={upcomingList}
              setFilterDate={setFilterDate}
              setUpcomingList={setUpcomingList}
              handleOk={handleOk}
              handleCancel={handleCancel}
              setMaintainbg={setMaintainbg}
              setApiPayload={setApiPayload}
              setUpcomingStatusValue={setUpcomingStatusValue}
              setUpcomingTypeValue={setUpcomingTypeValue}
            />
          </Modal>
        )}
      </div>
    </Layouts>
  );
}

export default Appointments;
